// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-HistoryModal-HistoryModal-module__eventTime";
var _2 = "webpack-pages-StudyList-HistoryModal-HistoryModal-module__iconWrapper";
var _3 = "webpack-pages-StudyList-HistoryModal-HistoryModal-module__studyTitle";
var _4 = "webpack-pages-StudyList-HistoryModal-HistoryModal-module__textWrapper";
export { _1 as "eventTime", _2 as "iconWrapper", _3 as "studyTitle", _4 as "textWrapper" }
